import { defineComponent as E, computed as p, createElementBlock as m, openBlock as o, normalizeClass as L, unref as c, createBlock as i, createCommentVNode as v, Fragment as k, renderList as j } from "vue";
import { useMediaQuery as M } from "@vueuse/core";
import { useRoute as V } from "vue-router";
import { useColorMode as D } from "@scalar/use-hooks/useColorMode";
import { DocumentClasses as S } from "@scalar-org/css";
import $ from "./HeaderLogoutButton.vue.js";
import H from "./HeaderItemGroup.vue.js";
import N from "./HeaderItemLink.vue.js";
import O from "./HeaderItemMeta.vue.js";
import w from "./HeaderItemSpacer.vue.js";
import A from "./HeaderItemTab.vue.js";
import C from "./HeaderItemVersionSelect.vue.js";
const W = /* @__PURE__ */ E({
  __name: "DocumentHeader",
  props: {
    project: {},
    versions: {},
    activeVersion: {},
    activeUids: {},
    activeGuide: {},
    headerLinks: {},
    isEditable: { type: Boolean },
    resolveInternalLinks: { type: Function }
  },
  emits: ["selectVersion", "navigate", "setSidebar", "toggleShow", "editOpenAPIDocument"],
  setup(r, { emit: g }) {
    const a = r, l = g, f = V(), { isDarkMode: y } = D(), b = p(() => y.value ? a.project.logo.darkMode : a.project.logo.lightMode), s = M("(max-width: 1000px)"), I = p(() => {
      const e = [...a.headerLinks];
      return s.value ? e.sort((n) => n.type === "version-selector" ? -1 : 1).filter((n) => n.type !== "spacer") : e;
    });
    function u(e, n) {
      l("navigate", n, e), s.value && l("setSidebar", !1);
    }
    function h(e, n) {
      l("toggleShow", e, n);
    }
    function d(e) {
      return a.activeUids?.includes(e.uid) || e.uid === f.name || e.uid === a.activeGuide || Object.values(f.params).includes(e.uid) ? !0 : e.type === "group" ? e.children.some((n) => d(n)) : !1;
    }
    return (e, n) => (o(), m("header", {
      class: L(["header", c(S).Header])
    }, [
      c(s) ? v("", !0) : (o(), i(O, {
        key: 0,
        logo: b.value,
        primaryVersionUid: r.project.activeVersionId,
        projectName: r.project.name
      }, null, 8, ["logo", "primaryVersionUid", "projectName"])),
      (o(!0), m(k, null, j(I.value, (t) => (o(), m(k, {
        key: t.uid
      }, [
        t.type === "group" ? (o(), i(H, {
          key: 0,
          group: t,
          isEditable: !!r.isEditable,
          isMobile: c(s),
          linkIsActive: d,
          resolveInternalLinks: r.resolveInternalLinks,
          onNavigate: u
        }, null, 8, ["group", "isEditable", "isMobile", "resolveInternalLinks"])) : t.type === "guide" || t.type === "reference" ? (o(), i(A, {
          key: 1,
          isEditable: !!r.isEditable,
          isMobile: c(s),
          linkIsActive: d,
          resolveInternalLinks: r.resolveInternalLinks,
          tab: t,
          onEditOpenAPIDocument: (P) => l("editOpenAPIDocument", t.uid),
          onNavigate: u,
          onToggleShow: h
        }, null, 8, ["isEditable", "isMobile", "resolveInternalLinks", "tab", "onEditOpenAPIDocument"])) : t.type === "link" ? (o(), i(N, {
          key: 2,
          link: t
        }, null, 8, ["link"])) : t.type === "spacer" ? (o(), i(w, { key: 3 })) : t.type === "version-selector" && Object.keys(r.versions).length > 1 ? (o(), i(C, {
          key: 4,
          activeVersion: r.activeVersion,
          versions: r.versions,
          onNavigate: u
        }, null, 8, ["activeVersion", "versions"])) : v("", !0)
      ], 64))), 128)),
      r.project.isPrivate && !r.isEditable ? (o(), i($, { key: 1 })) : v("", !0)
    ], 2));
  }
});
export {
  W as default
};
